// Parâmetros gerais do sistema (issue #6).

import type { DataFaturamento, Snapshot } from "./snapshot.ts";

export class ErroConfig extends Error {}

/** Slogan e WhatsApp do rodapé da tabela de preços exportada. */
export function definirRodapeExport(
  snapshot: Snapshot,
  slogan: string,
  whatsapp: string,
): Snapshot {
  const s = slogan.trim();
  const w = whatsapp.trim();
  if (s === "") throw new ErroConfig("Informe o slogan do rodapé.");
  if (w === "") throw new ErroConfig("Informe o número de WhatsApp.");
  return {
    ...snapshot,
    config: { ...snapshot.config, rodapeExport: { slogan: s, whatsapp: w } },
  };
}

/** Qual data do Lote o faturamento usa como referência (coleta ou devolução). */
export function definirDataFaturamento(
  snapshot: Snapshot,
  modo: DataFaturamento,
): Snapshot {
  if (modo !== "coleta" && modo !== "devolucao") {
    throw new ErroConfig("Data de faturamento inválida.");
  }
  return { ...snapshot, config: { ...snapshot.config, dataFaturamento: modo } };
}

/** Maior período padrão aceito para o Dashboard: 2 anos de meses anteriores. */
const MESES_PADRAO_DASHBOARD_MAXIMO = 24;

/**
 * Período padrão do Dashboard Operacional (ADR-0032): os N meses inteiros
 * anteriores + o mês corrente. 0 = só o mês corrente.
 */
export function definirMesesPadraoDashboard(snapshot: Snapshot, meses: number): Snapshot {
  if (!Number.isInteger(meses) || meses < 0 || meses > MESES_PADRAO_DASHBOARD_MAXIMO) {
    throw new ErroConfig(
      `Período padrão do Dashboard inválido (0 a ${MESES_PADRAO_DASHBOARD_MAXIMO} meses).`,
    );
  }
  return { ...snapshot, config: { ...snapshot.config, mesesPadraoDashboard: meses } };
}

/** Teto do volume mínimo — acima disso, nenhum item disputaria o ranking. */
const VOLUME_MINIMO_RANKING_MAXIMO = 100000;

/**
 * Volume mínimo (peças na base da taxa) para um item disputar o ranking por %
 * do Dashboard; abaixo dele o item vai para o fim, esmaecido (ADR-0032 §9).
 */
export function definirVolumeMinimoRanking(snapshot: Snapshot, pecas: number): Snapshot {
  if (!Number.isInteger(pecas) || pecas < 1 || pecas > VOLUME_MINIMO_RANKING_MAXIMO) {
    throw new ErroConfig(`Volume mínimo inválido (1 a ${VOLUME_MINIMO_RANKING_MAXIMO} peças).`);
  }
  return { ...snapshot, config: { ...snapshot.config, volumeMinimoRanking: pecas } };
}